export const RECONNECT_COOLDOWN_MS = 20_000
const RECONNECT_COOLDOWN_KEY = 'nm.walletReconnectCooldownAt'

export function readLastReconnectAt(): number {
  if (typeof window === 'undefined') return 0
  try {
    const raw = window.sessionStorage.getItem(RECONNECT_COOLDOWN_KEY)
    const parsed = raw ? Number.parseInt(raw, 10) : 0
    return Number.isFinite(parsed) ? parsed : 0
  } catch {
    return 0
  }
}

/** Evita que visibility/pageshow disparen reconnect y abran MetaMask en bucle. */
export function markWalletReconnectCooldown(now = Date.now()): void {
  if (typeof window === 'undefined') return
  try {
    window.sessionStorage.setItem(RECONNECT_COOLDOWN_KEY, String(now))
  } catch {
    /* quota / private mode */
  }
}

export function canAttemptWalletReconnect(now = Date.now()): boolean {
  return now - readLastReconnectAt() >= RECONNECT_COOLDOWN_MS
}
